// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { AlertRecipientOperationsService } from '../generated/api/alertRecipientOperations.service';

@Injectable({ providedIn: 'root' })
export class AlertRecipientOperationsClientService {
  constructor(private readonly client: AlertRecipientOperationsService) {}
  // <generated-client-wrappers:methods>
  create(
    request: WrapperApi.AlertRecipientSaveRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('AlertRecipientOperationsService is not available');
    return this.client.alertRecipientOperationsCreate(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  delete(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('AlertRecipientOperationsService is not available');
    return this.client.alertRecipientOperationsDelete(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  disable(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('AlertRecipientOperationsService is not available');
    return this.client.alertRecipientOperationsDisable(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  enable(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('AlertRecipientOperationsService is not available');
    return this.client.alertRecipientOperationsEnable(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  get(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AlertRecipientDetail> {
    if (!this.client)
      throw new Error('AlertRecipientOperationsService is not available');
    return this.client.alertRecipientOperationsGet(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  query(
    query: WrapperApi.AlertRecipientQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AlertRecipientPage> {
    if (!this.client)
      throw new Error('AlertRecipientOperationsService is not available');
    return this.client.alertRecipientOperationsQuery(
      query,
      'body',
      reportProgress,
      options,
    );
  }

  update(
    id: string,
    request: WrapperApi.AlertRecipientSaveRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: '*/*';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Blob> {
    if (!this.client)
      throw new Error('AlertRecipientOperationsService is not available');
    return this.client.alertRecipientOperationsUpdate(
      id,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
